import { useQuery } from '@tanstack/react-query';

import { contentTestQuery } from '../api/content-test.api';

export const useContentTest = (id: string | null | undefined, enabled = true) => {
  return useQuery({
    ...contentTestQuery(id),
    enabled: enabled && !!id,
  });
};
